import SahamDialog from 'components/SahamDialog';
import styled from 'styled-components';

export const RefusalDialogWrapper = styled(SahamDialog)`
  .reason-wrapper {
    padding: 9px;
  }
  &.refusal-content {
    min-width: 500px;
  }
`;
